import type { FeedPost } from '@wlb/shared/types/post';

/** FeedPost media is broad (RN ImageSource | string | {uri}) — web uses string/{uri}. */
type PostMedia = FeedPost['image'] | FeedPost['images'];

export const resolvePostImages = (media: PostMedia): string[] => {
  if (!media) return [];
  if (Array.isArray(media)) return media.flatMap(item => resolvePostImages(item));
  if (typeof media === 'string') return media.trim() ? [media] : [];
  if (typeof media === 'object' && 'uri' in media) {
    return typeof media.uri === 'string' && media.uri.trim() ? [media.uri] : [];
  }
  return [];
};

export const resolvePostImageUri = (media: FeedPost['image']): string | null =>
  resolvePostImages(media)[0] ?? null;

/**
 * Every photo of a post, in order. The mappers put the whole album in `images`
 * and only the primary photo in `image`, so a multi-image post read from `image`
 * alone collapses to its first picture.
 */
export const resolvePostAlbum = (post: Pick<FeedPost, 'image' | 'images'>): string[] => {
  const album = resolvePostImages(post.images);
  return album.length > 0 ? album : resolvePostImages(post.image);
};
